import { getAxiosClientWithToken } from './index';

export const getSystemNotification = () => {
    const restClient = getAxiosClientWithToken();
    return restClient.get('/company/system-notification');
};
